import { ThemeEvents, VariantUpdateEvent } from '@theme/events'
import { morph } from '@theme/morph'

class ProductInventory extends HTMLElement {
  connectedCallback() {
    document.addEventListener(ThemeEvents.variantUpdate, this.updateInventory)
  }

  disconnectedCallback() {
    document.removeEventListener(
      ThemeEvents.variantUpdate,
      this.updateInventory
    )
  }

  /**
   * Updates the inventory.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateInventory = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return
    }

    const newInventory =
      event.detail.data.html.querySelector('product-inventory')

    if (!newInventory) {
      return
    }

    const productInventories = document.querySelectorAll(
      `product-inventory[data-product-id="${event.detail.data.productId}"]`
    )
    productInventories.forEach((productInventory) => {
      morph(productInventory, newInventory, { childrenOnly: true })
    })
  }
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory)
}
